import React, { type ReactNode } from 'react';

interface DetailRowProps {
  label: ReactNode;
  value?: string;
}

const DetailRow = ({ label, value }: DetailRowProps) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-base font-semibold text-secondary">{label}</span>
      <span className="text-base font-normal text-tertiary">{value ?? '—'}</span>
    </div>
  );
};

export default DetailRow;
